import {
  differenceInMinutes,
  differenceInHours,
  differenceInDays,
  differenceInMonths,
  differenceInYears,
} from 'date-fns';

export const getAge = (createdAt: string) => {
  const increments = {
    y: differenceInYears,
    mo: differenceInMonths,
    d: differenceInDays,
    h: differenceInHours,
    m: differenceInMinutes,
  };
  for (const [unit, ageInUnit] of Object.entries(increments)) {
    const age = ageInUnit(Date.now(), Date.parse(createdAt));
    if (age > 0) return age + unit;
  }
  return 'just now';
};
